import React from "react";

export default function ColorFrame40({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <circle
          cx="138"
          cy="151.757"
          r="111"
          fill="#fff"
          stroke="#EA2F2F"
          strokeWidth="24"
        ></circle>
        <circle
          cx="140.177"
          cy="47.805"
          r="43.305"
          fill="#fff"
          stroke="#EA2F2F"
          strokeWidth="7"
        ></circle>
        <path
          fill="#EA2F2F"
          d="M113 56H130V111H113z"
          transform="rotate(-90 113 56)"
        ></path>
        <path fill="#EA2F2F" d="M131 20H149V75H131z"></path>
        {children}
      </g>
    </svg>
  );
}
